import { Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import proxy from "../../proxy";
import { Center, Spinner } from "@chakra-ui/react";

const ProtectedRoute = ({ children }) => {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    axios
      .get(`${proxy}server_mts/admin/CheckAuth.php`, { withCredentials: true })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("denied"));
  }, []);

  if (status === "checking") {
    return (
      <Center minH="100vh" bg="gray.900">
        <Spinner size="xl" color="teal.400" />
      </Center>
    );
  }

  if (status === "denied") {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
